import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-common-answers-to-1099-int-faq'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'>
          Form 1099&#8211;INT:
        </Typography>
        <Accordion
          id='faq-common-1099-int-faq'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'life-insurance-faq-access-1099-online-int-faq',
              title: <>I received a Form 1099&#8211;INT as beneficiary of a life insurance contract. I thought death benefits were tax&#8211;free. Why did I receive a Form 1099&#8211;INT&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  While the death benefits from a life insurance contract are generally tax&#8211;free, interest may be paid from the date of death until the claim is settled. The IRS requires that we report the interest you earned on Form 1099&#8211;INT.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
